export const PROFESSION_REGISTRATION_ERROR = 'PROFESSION_REGISTRATION_ERROR';
export const PROFESSION_REGISTRATION_VERIFIED_ERROR = 'PROFESSION_REGISTRATION_VERIFIED_ERROR';
export const PROFESSION_REGISTRATION_LOADING = 'PROFESSION_REGISTRATION_LOADING';
export const PROFESSION_REGISTRATION_VERIFIED_LOADING = 'PROFESSION_REGISTRATION_VERIFIED_LOADING';
export const PROFESSION_REGISTRATION_VERIFIED_SUCCESS = 'PROFESSION_REGISTRATION_VERIFIED_SUCCESS';

export const INITIATE_PROFESSION_REGISTRATION_APPLICATION_SUCCESS =
  'INITIATE_PROFESSION_REGISTRATION_APPLICATION_SUCCESS';

export const FETCH_APPLICATION_PROFESSION_REGISTRATION_SUCCESS = 'FETCH_APPLICATION_PROFESSION_REGISTRATION_SUCCESS';
export const SAVE_APPLICATION_PROFESSION_REGISTRATION_SUCCESS = 'SAVE_APPLICATION_PROFESSION_REGISTRATION_SUCCESS';

export const CHANGE_PROFESSION_REGISTRATION_STEP = 'CHANGE_PROFESSION_REGISTRATION_STEP';
export const PROFESSION_REGISTRATION_CLEAR_DATA = 'PROFESSION_REGISTRATION_CLEAR_DATA';

export const CHECKOUT_PROFESSION_REGISTRATION_APPLICATION_SUCCESS =
  'CHECKOUT_PROFESSION_REGISTRATION_APPLICATION_SUCCESS';
export const PROFESSION_REGISTRATION_CANCEL_APPLICATION_SUCCESS = 'PROFESSION_REGISTRATION_CANCEL_APPLICATION_SUCCESS';

export const FETCH_DOCUMENTS_PROFESSION_REGISTRATION_SUCCESS = 'FETCH_DOCUMENTS_PROFESSION_REGISTRATION_SUCCESS';
export const PROFESSION_REGISTRATION_PROPERTY_DOCUMENTS_SUCCESS = 'PROFESSION_REGISTRATION_PROPERTY_DOCUMENTS_SUCCESS';
export const DOWNLOAD_DOCUMENT_PROFESSION_REGISTRATION_SUCCESS = 'DOWNLOAD_DOCUMENT_PROFESSION_REGISTRATION_SUCCESS';
export const UPLOAD_PROFESSION_REGISTRATION_DOCUMENT_SUCCESS = 'UPLOAD_PROFESSION_REGISTRATION_DOCUMENT_SUCCESS';

export const GET_PROFESSION_TYPES = 'GET_PROFESSION_TYPES';
export const SET_PROFESSION_TYPES = 'SET_PROFESSION_TYPES';

export const UPDATE_PROFESSION_STATE = 'UPDATE_PROFESSION_STATE';
export const DOCUMENT_ERROR = 'DOCUMENT_ERROR';
export const RESET_APP_STATE = 'RESET_APP_STATE';
